import { hasRealAPICredentials, getAPIBaseURL } from 'src/config/api'
import mockAPI from 'src/api/mock/mockAPI'

const list = async (path: string) => {
  // Use mock data if we don't have real API credentials
  if (!hasRealAPICredentials()) {
    console.log(`📡 Using mock data for: ${path}`)
    return await mockAPI.list(path)
  }

  const fetchParams = {
    method: 'GET',
    headers: {
      'x-api-key': process.env.REACT_APP_SAMSARA_API_KEY
    }
  }

  const url = `${getAPIBaseURL()}/gamedata/solid/${path}/list`
  // @ts-expect-error
  const data = await fetch(url, fetchParams)
  return await data.json()
}

const post = async (path: string, item: any, isVerified: boolean) => {
  // Use mock data if we don't have real API credentials
  if (!hasRealAPICredentials()) {
    console.log('Using mock data for POST:', path)
    return await mockAPI.post(path, item, isVerified)
  }

  const fetchParams = {
    method: 'POST',
    headers: {
      'x-api-key': process.env.REACT_APP_SAMSARA_API_KEY
    },
    body: JSON.stringify({ ...item, isVerified: !!isVerified })
  }
  
  const url = `${getAPIBaseURL()}/gamedata/solid/${path}/post`
  // @ts-expect-error
  const response = await fetch(url, fetchParams)
  return await response.json()
}

const put = async (path: string, item: any, isVerified: boolean) => {
  // Use mock data if we don't have real API credentials
  if (!hasRealAPICredentials()) {
    console.log('Using mock data for PUT:', path)
    return await mockAPI.put(path, item, isVerified)
  }

  const fetchParams = {
    method: 'PUT',
    headers: {
      'x-api-key': process.env.REACT_APP_SAMSARA_API_KEY
    },
    body: JSON.stringify({ ...item, isVerified: !!isVerified })
  }
  
  const url = `${getAPIBaseURL()}/gamedata/solid/${path}/put`
  // @ts-expect-error
  const response = await fetch(url, fetchParams)
  return await response.json()
}

const _delete = async (path: string, item: boolean) => {
  // Use mock data if we don't have real API credentials
  if (!hasRealAPICredentials()) {
    console.log('Using mock data for DELETE:', path)
    return await mockAPI.delete(path, item)
  }

  const fetchParams = {
    method: 'DELETE',
    headers: {
      'x-api-key': process.env.REACT_APP_SAMSARA_API_KEY
    },
    body: JSON.stringify(item)
  }
  
  const url = `${getAPIBaseURL()}/gamedata/solid/${path}/delete`
  // @ts-expect-error
  const response = await fetch(url, fetchParams)
  return await response.json()
}

export default {
  list,
  post,
  put,
  delete: _delete
}
